import * as React from 'react';
import {withTranslation} from 'react-i18next';
import {compose} from "redux";
import {connect} from "react-redux";
import {RootState} from "Redux/Reducers/_RootReducer";
import {Types} from "Models/ContractModel";
import ContractSingleDto = Types.ContractSingleDto;
import * as ErrorActions from "Redux/Actions/ErrorActions";
import * as ViewManagementModule from "Modules/ViewManagementModule";
import {history} from "HelperFunctions/root";
import * as Dictionary from "Models/Dictionary";
import EditContractForm from "components/Contract/EditContractForm";
import {ContractActions} from "Redux/Actions/ContractActions";
import EditContractBody = Types.EditContractBody;
import * as VehiclesModule from "Modules/VehiclesModule";

type Props = {
    history?: any;
    match: any;
};

type ConnectedProps = {
    currentContractNumber: string;
    activeVehicleDetails: VehiclesModule.Types.CarDto;
    t?: Function;
};

type DispatchedP = {
    editContractData: Function;
    showInfoBox: Function;
    getVehicleById: (id: number) => void;
};

type State = {
    currentContract: ContractSingleDto;
};

class EditContract extends React.Component<Props & ConnectedProps & DispatchedP, State> {
    constructor(props: Props & ConnectedProps & DispatchedP) {
        super(props);
    }

    public async componentDidMount() {
        const contractId = this.props.match?.params.contractId;
        if (contractId && !this.props.activeVehicleDetails) {
            await this.props.getVehicleById(contractId);
        }
    }

    public handleSubmit = async (formData: EditContractBody) => {
        formData.vin = this.props.activeVehicleDetails?.vin;
        formData.terminalPassword = '';
        try {
            await this.props.editContractData(formData);
            history.push(`${Dictionary.PageUrl.get(ViewManagementModule.EnumTypes.Page.CONTRACT_MANAGEMENT)}`);
        } catch (e) {
            // console.log(e);
        }
    };

    public render() {
        return (
            <div className="main__content main__content--scroll">
                <h3 className="main__title">
                    Edycja umowy
                </h3>
                <div className="font-xmd mb-40">
                    Numer umowy: <span className="bold">{this.props.currentContractNumber}</span>
                    <br/>
                    VIN: <span className="bold">{this.props.activeVehicleDetails?.vin}</span>
                </div>
                <EditContractForm onSubmit={this.handleSubmit}/>
            </div>
        );
    }
}

function mapStateToProps(state: RootState): ConnectedProps {
    return {
        currentContractNumber: state.vehiclesStore.activeVehicleDetails?.contractNumber,
        activeVehicleDetails: state.vehiclesStore.activeVehicleDetails,
    };
}


function mapDispatchToProps(dispatch: any): DispatchedP {
    return {
        getVehicleById: (id: number) => dispatch(VehiclesModule.Actions.getCarById(id)),
        editContractData: (formData: EditContractBody) => dispatch(ContractActions.editContract(formData)),
        showInfoBox: (type, message) => dispatch(ErrorActions.setNewsForMoment({type, message}))
    }
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withTranslation(['carDetails', 'forms', 'dictionary'])
)(EditContract) as React.ComponentClass<any>;



// WEBPACK FOOTER //
// ./src/components/Contract/EditContract.tsx